import { Routes, Route, Navigate } from "react-router-dom";
import React from "react";
import Login from "./Login";
import Dashboard from "../pages/Dashboard";
import Layout from "../components/shared/Layout";
import AddStaff from "../pages/AddStaff";
import Contact from "../pages/Contact";
import Map from "../pages/Maps";
import ViewStaff from "../pages/ViewStaff";
import ChangePassword from "../pages/ChangePassword";
import User from "../pages/User";
import ViewUserTransaction from "../pages/ViewUserTransaction";
import RefundRequest from "../pages/RefundRequest";
import Doctor from "../pages/Doctor";
import AddDoctor from "../pages/AddDoctor";
import Department from "../pages/Department";
import CreateDepartment from "../pages/CreateDepartment";
import CheckRefers from "../pages/Refer";
import Medicine from "../pages/Medicine";
import UpdateRefer from "../pages/UpdateRefer";
import ViewPharmaStaff from "../pages/ViewPharmaStaff";
import AddLabReporter from "../pages/AddLabReporter";
import ViewLabReporter from "../pages/ViewLabReporter";
import ViewAppointment from "../pages/ViewAppointments";
import AddPharmaStaff from "../pages/AddPharmaStaff";
import AddMedicine from "../pages/AddMedicine";
import AddPatient from "../pages/AddPatient";
import UpdateDepartment from "../pages/UpdateDepartment";
import ViewOngoingAppointment from "../pages/ViewOngoingAppointment";
import ViewReferralAppointment from "../pages/ReferredAppointments";
import ViewEndedAppointmentByDoctor from "../pages/EndedAppointment";
import ReferDepartmentByDoctor from "./doctor_modal/ongoing/refer_department";
import ViewReferralAppointmentToMe from "../pages/referredToMeAppointment";
import AddLabReport from "../pages/AddReport";
import PdfViewPage from "../pages/viewReportPdf.jsx";
import AddSymptoms from "../pages/AddSymptoms.jsx";
import ViewSymptoms from "../pages/ViewSymptoms.jsx";
import UpdatePrescription from "./doctor_modal/ongoing/update_prescription.jsx";
import AddPrescription from "./doctor_modal/ongoing/add_prescription.jsx";
import AddAppointmentTime from "../pages/addAppointmentTime.jsx";
import ViewAppointmentDateTime from "../pages/ViewAppointmentDateTime.jsx";
import UpdateAppointmentDateTime from "../pages/UpdateAppointmentTime.jsx";
import ViewLabReports from "../pages/ViewReports.jsx";
import ViewReportByAppointmentId from "../pages/ViewReportWrtAppointment.jsx";
import UpdateLabReport from "../pages/UpdateLabReport.jsx";
import UpdateMedicine from "../pages/UpdateMedicine.jsx";
import ViewFollowUpAppointments from "../pages/ViewFollowUpAppointments.jsx";
import ViewPrescription from "../pages/viewPrescription.jsx";
import ViewInProgressAppointment from "../pages/ViewInProgressAppointments.jsx";
import ViewCancelStatusAppointment from "../pages/ViewCancelStatusAppointments.jsx";
import ViewCompletedAppointment from "../pages/viewCompletedAppointmentsStaff.jsx";
import ViewStaffReferredAppointment from "../pages/ViewStaffReferredAppointments.jsx";
import AddNewAppointmentStaff from "../pages/AddNewAppointmentByStaff.jsx";
import UpdateNewAppointmentStaff from "../pages/UpdateNewAppointment.jsx";
import ReferredDepartmentByStaff from "./staff_modal/referredDepartment.jsx";
import ChangeReferredDepartmentByStaff from "./staff_modal/changeDepartement.jsx";
import UpdateReferredAndFollowUpAppointmentDateTime from "../pages/updateReferAndFollowupDateTime.jsx";
import AddFollowUpDateTime from "./staff_modal/addFollowUpDateTime.jsx";
import BillsPage from "../pages/viewBillsPage.jsx";
import AddBill from "./billing/AddBill.jsx";
import PrintInvoice from "./billing/printInvoice.jsx";
import UpdateBill from "./billing/UpdateBill.jsx";
import UpdateDoctor from "../pages/UpdateDoctor.jsx";
import UpdateSymptom from "../pages/updateSymptom.jsx";
import UpdateStaff from "../pages/updateStaff.jsx";
import UpdateLabReporter from "../pages/UpdateLabReporter.jsx";
import UpdatePharmaStaff from "../pages/UpdatePharmaStaff.jsx";
import UnauthorizedPage from "../lib/constants/unauthorized.jsx";
import PageNotFound from "../lib/constants/PageNotFound.jsx";
import UpdatePatient from "../pages/UpdatePatient.jsx";
import ProtectedRoute from "../lib/constants/routeProtection.jsx";
import UserProfile from "../pages/UserProfile.jsx";
import ViewDoctorMedicineByAdmin from "../pages/viewDoctorMedicineAdmin.jsx";
import AddDoctorMedicineAdmin from "../pages/addDoctorMedicineByAdmin.jsx";
import UpdateDoctorMedicineAdmin from "../pages/updateDoctorMedicineAdmin.jsx";
import ManagePasswordAdmin from "../pages/managePasswordsAdmin.jsx";
import ViewLabBillsPage from "../pages/viewLabBillsStaff.jsx";

const Mid = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/pagenotfound" element={<PageNotFound />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute
              roles={["admin", "doctor", "staff", "labreporter", "pharma"]}
              component={Layout}
            />
          }
        >
          <Route
            index
            element={
              <ProtectedRoute
                roles={["admin", "doctor", "staff", "labreporter", "pharma"]}
                component={Dashboard}
              />
            }
          />

          <Route
            path="/dashboard/reset/password/:userId"
            element={
              <ProtectedRoute
                roles={["admin"]}
                component={ManagePasswordAdmin}
              />
            }
          />

          {/* Doctor And Staff */}
          <Route
            path="/dashboard/viewreport/:appointmentId"
            element={
              <ProtectedRoute
                roles={["doctor", "staff", "labreporter"]}
                component={ViewReportByAppointmentId}
              />
            }
          />

          {/* Admin */}
          <Route
            path="/dashboard/addstaff"
            element={<ProtectedRoute roles={["admin"]} component={AddStaff} />}
          />
          <Route
            path="/dashboard/viewstaff"
            element={<ProtectedRoute roles={["admin"]} component={ViewStaff} />}
          />

          {/* Doctor */}
          <Route
            path="/dashboard/view_reportdr"
            element={
              <ProtectedRoute
                roles={["doctor", "staff", "labreporter"]}
                component={PdfViewPage}
              />
            }
          />
          <Route
            path="/dashboard/viewOngoingAppointmentbyDoctor"
            element={
              <ProtectedRoute
                roles={["doctor"]}
                component={ViewOngoingAppointment}
              />
            }
          />
          <Route
            path="/dashboard/view/followup/appointments"
            element={
              <ProtectedRoute
                roles={["doctor"]}
                component={ViewFollowUpAppointments}
              />
            }
          />
          <Route
            path="/dashboard/viewReferredAppointmentbyDoctor"
            element={
              <ProtectedRoute
                roles={["doctor"]}
                component={ViewReferralAppointment}
              />
            }
          />
          <Route
            path="/dashboard/viewReferredAppointment/toDoctor"
            element={
              <ProtectedRoute
                roles={["doctor"]}
                component={ViewReferralAppointmentToMe}
              />
            }
          />
          <Route
            path="/dashboard/viewEndedAppointmentbyDoctor"
            element={
              <ProtectedRoute
                roles={["doctor"]}
                component={ViewEndedAppointmentByDoctor}
              />
            }
          />
          <Route
            path="/dashboard/viewOngoingAppointmentbyDoctor/refer_department/:appointmentId/:departmentId"
            element={
              <ProtectedRoute
                roles={["doctor"]}
                component={ReferDepartmentByDoctor}
              />
            }
          />
          <Route
            path="/dashboard/viewOngoingAppointmentbyDoctor/add_prescription/:appointmentId"
            element={
              <ProtectedRoute
                roles={["doctor", "staff"]}
                component={AddPrescription}
              />
            }
          />
          <Route
            path="/dashboard/viewOngoingAppointmentbyDoctor/update_prescription/:prescriptionId"
            element={
              <ProtectedRoute
                roles={["doctor", "staff"]}
                component={UpdatePrescription}
              />
            }
          />
          <Route
            path="/dashboard/viewAppointmentbyDoctor/view/prescription/:appointmentId"
            element={
              <ProtectedRoute
                roles={["doctor", "staff"]}
                component={ViewPrescription}
              />
            }
          />

          {/* STAFF */}
          <Route
            path="/dashboard/view_appointment/datetime"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={ViewAppointmentDateTime}
              />
            }
          />
          <Route
            path="/dashboard/add/appointment_datetime"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={AddAppointmentTime}
              />
            }
          />
          <Route
            path="/dashboard/update/appointment_datetime/:dateTimeId"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={UpdateAppointmentDateTime}
              />
            }
          />
          <Route
            path="/dashboard/addstaff"
            element={<ProtectedRoute roles={["admin"]} component={AddStaff} />}
          />
          <Route
            path="/dashboard/update/staff/:staffId"
            element={
              <ProtectedRoute roles={["admin"]} component={UpdateStaff} />
            }
          />
          <Route
            path="/dashboard/viewstaff"
            element={<ProtectedRoute roles={["admin"]} component={ViewStaff} />}
          />

          {/* Appointment for staff */}
          <Route
            path="/dashboard/viewappointment"
            element={
              <ProtectedRoute
                roles={["admin", "staff", "labreporter"]}
                component={ViewAppointment}
              />
            }
          />
          <Route
            path="/dashboard/add/new/appointment"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={AddNewAppointmentStaff}
              />
            }
          />
          <Route
            path="/dashboard/update/new/appointment/:appointmentId"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={UpdateNewAppointmentStaff}
              />
            }
          />
          <Route
            path="/dashboard/view/inprogress/appointment"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={ViewInProgressAppointment}
              />
            }
          />
          <Route
            path="/dashboard/view/referred/appointment"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={ViewStaffReferredAppointment}
              />
            }
          />
          <Route
            path="/dashboard/view/cancelstatus/appointment"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={ViewCancelStatusAppointment}
              />
            }
          />
          <Route
            path="/dashboard/view/completed/appointment"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={ViewCompletedAppointment}
              />
            }
          />

          <Route
            path="/dashboard/staff/refer_department/:appointmentId"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={ReferredDepartmentByStaff}
              />
            }
          />
          <Route
            path="/dashboard/staff/change/refer_department/:appointmentId"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={ChangeReferredDepartmentByStaff}
              />
            }
          />
          <Route
            path="/dashboard/staff/update/datetime/appointment/:appointmentId"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={UpdateReferredAndFollowUpAppointmentDateTime}
              />
            }
          />
          <Route
            path="/dashboard/staff/add/followup/datetime/appointment/:appointmentId"
            element={
              <ProtectedRoute
                roles={["staff"]}
                component={AddFollowUpDateTime}
              />
            }
          />

          {/* Generate lab bills by staff */}
          <Route
            path="/dashboard/get/generated/lab-bills"
            element={
              <ProtectedRoute roles={["staff"]} component={ViewLabBillsPage} />
            }
          />

          {/* PHARMA STAFF */}
          <Route
            path="/dashboard/addpharmastaff"
            element={
              <ProtectedRoute roles={["admin"]} component={AddPharmaStaff} />
            }
          />
          <Route
            path="/dashboard/update/pharmastaff/:userId"
            element={
              <ProtectedRoute roles={["admin"]} component={UpdatePharmaStaff} />
            }
          />
          <Route
            path="/dashboard/viewpharmastaff"
            element={
              <ProtectedRoute roles={["admin"]} component={ViewPharmaStaff} />
            }
          />

          {/* Lab Reporter */}
          <Route
            path="/dashboard/addlabreporter"
            element={
              <ProtectedRoute roles={["admin"]} component={AddLabReporter} />
            }
          />
          <Route
            path="/dashboard/update/labreporter/:userId"
            element={
              <ProtectedRoute roles={["admin"]} component={UpdateLabReporter} />
            }
          />
          <Route
            path="/dashboard/viewlabreporter"
            element={
              <ProtectedRoute roles={["admin"]} component={ViewLabReporter} />
            }
          />
          <Route
            path="/dashboard/add_report/:appointmentId"
            element={
              <ProtectedRoute
                roles={["labreporter"]}
                component={AddLabReport}
              />
            }
          />
          <Route
            path="/dashboard/view/labreports"
            element={
              <ProtectedRoute
                roles={["labreporter"]}
                component={ViewLabReports}
              />
            }
          />
          <Route
            path="/dashboard/update/report/:reportId"
            element={
              <ProtectedRoute
                roles={["labreporter"]}
                component={UpdateLabReport}
              />
            }
          />

          {/* Patient */}
          <Route
            path="/dashboard/viewuser"
            element={
              <ProtectedRoute roles={["admin", "staff"]} component={User} />
            }
          />
          <Route
            path="/dashboard/patientadd"
            element={
              <ProtectedRoute roles={["staff"]} component={AddPatient} />
            }
          />
          <Route
            path="/dashboard/update/patient/:patientId"
            element={
              <ProtectedRoute roles={["staff"]} component={UpdatePatient} />
            }
          />
          <Route
            path="/dashboard/viewuser/user_transaction/:user_id"
            element={
              <ProtectedRoute
                roles={["admin", "doctor", "staff", "labreporter", "pharma"]}
                component={ViewUserTransaction}
              />
            }
          />

          {/* Symptoms */}
          <Route
            path="/dashboard/symptoms"
            element={
              <ProtectedRoute roles={["admin"]} component={ViewSymptoms} />
            }
          />
          <Route
            path="/dashboard/add_symptom"
            element={
              <ProtectedRoute roles={["admin"]} component={AddSymptoms} />
            }
          />
          <Route
            path="/dashboard/update/symptom/:id"
            element={
              <ProtectedRoute roles={["admin"]} component={UpdateSymptom} />
            }
          />

          {/* Doctor */}
          <Route
            path="/dashboard/doctoradd"
            element={<ProtectedRoute roles={["admin"]} component={AddDoctor} />}
          />
          <Route
            path="/dashboard/update/doctor/:doctorId"
            element={
              <ProtectedRoute roles={["admin"]} component={UpdateDoctor} />
            }
          />
          <Route
            path="/dashboard/viewdoctor"
            element={<ProtectedRoute roles={["admin"]} component={Doctor} />}
          />

          {/* DEPARTMENT */}
          <Route
            path="/dashboard/department"
            element={
              <ProtectedRoute roles={["admin"]} component={Department} />
            }
          />
          <Route
            path="/dashboard/department/create"
            element={
              <ProtectedRoute roles={["admin"]} component={CreateDepartment} />
            }
          />
          <Route
            path="/dashboard/department/update/:departmentId"
            element={
              <ProtectedRoute roles={["admin"]} component={UpdateDepartment} />
            }
          />

          {/* Refers */}
          <Route
            path="/dashboard/refer"
            element={
              <ProtectedRoute roles={["staff"]} component={CheckRefers} />
            }
          />
          {/* <Route path="/dashboard/refer/create" element={<AddPartner />} /> */}
          <Route
            path="/dashboard/refer/update/:appointment_id"
            element={
              <ProtectedRoute roles={["staff"]} component={UpdateRefer} />
            }
          />

          {/* Medicine */}
          <Route
            path="/dashboard/medicine"
            element={<ProtectedRoute roles={["pharma"]} component={Medicine} />}
          />
          {/* <Route path="/dashboard/medicine/billing" element={<Medicine />} /> */}
          <Route
            path="/dashboard/medicine/create"
            element={
              <ProtectedRoute roles={["pharma"]} component={AddMedicine} />
            }
          />

          {/* by admin */}
          <Route
            path="/dashboard/view/medicine"
            element={
              <ProtectedRoute
                roles={["admin"]}
                component={ViewDoctorMedicineByAdmin}
              />
            }
          />
          <Route
            path="/dashboard/add/medicine"
            element={
              <ProtectedRoute
                roles={["admin"]}
                component={AddDoctorMedicineAdmin}
              />
            }
          />
          {/* by admin */}
          <Route
            path="/dashboard/update/medicine/:medId"
            element={
              <ProtectedRoute
                roles={["admin"]}
                component={UpdateDoctorMedicineAdmin}
              />
            }
          />

          {/* by pharma different routes */}
          <Route
            path="/dashboard/medicine/update/:medId"
            element={
              <ProtectedRoute roles={["pharma"]} component={UpdateMedicine} />
            }
          />
          <Route
            path="/dashboard/bills"
            element={
              <ProtectedRoute roles={["pharma"]} component={BillsPage} />
            }
          />
          <Route
            path="/dashboard/generate/bill"
            element={<ProtectedRoute roles={["pharma"]} component={AddBill} />}
          />
          <Route
            path="/dashboard/update/bill/:billID"
            element={
              <ProtectedRoute roles={["pharma"]} component={UpdateBill} />
            }
          />
          <Route
            path="/dashboard/pharmacy/print-invoice/:billID"
            element={
              <ProtectedRoute roles={["pharma"]} component={PrintInvoice} />
            }
          />

          {/* Help and Support */}
          <Route
            path="/dashboard/refund_requests"
            element={
              <ProtectedRoute
                roles={["admin", "doctor", "staff", "labreporter", "pharma"]}
                component={RefundRequest}
              />
            }
          />
          <Route
            path="/dashboard/contact"
            element={
              <ProtectedRoute
                roles={["admin", "doctor", "staff", "labreporter", "pharma"]}
                component={Contact}
              />
            }
          />
          <Route
            path="/dashboard/map"
            element={
              <ProtectedRoute
                roles={["admin", "doctor", "staff", "labreporter", "pharma"]}
                component={Map}
              />
            }
          />

          {/* Settings */}
          <Route
            path="/dashboard/changepassword"
            element={
              <ProtectedRoute
                roles={["admin", "doctor", "staff", "labreporter", "pharma"]}
                component={ChangePassword}
              />
            }
          />
          <Route
            path="/dashboard/profile"
            element={
              <ProtectedRoute
                roles={["doctor", "staff", "labreporter", "pharma"]}
                component={UserProfile}
              />
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/pagenotfound" />} />
      </Routes>
    </>
  );
};
export default Mid;
